import styled from 'styled-components';
import { mainColor, mainFont } from '../../styles/global';

export const TestimonialWrapper = styled.div`  
    padding: 0rem calc((100vw - 1220px) / 2);
    padding-bottom:50px;
    h1{ 
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 750;
        font-size: 60px;
        margin-bottom: 50px;
        letter-spacing: 0.01em;
        text-align: center;
        color:${mainColor};
        @media screen and (max-width: 768px) {
            font-size: 20px;
            line-height: 60px;
            margin-bottom: 0px;

        }
    }
`;

export const TestimonialGrid = styled.div`
    overflow-x:scroll;
    display:flex;
    gap:5%;
    padding:2%;
    ::-webkit-scrollbar {
        display: none;
      }
  

`;

export const TestimonialCard = styled.div`
        min-width: 595px;
        height: 284px;
        display:flex;
        flex-direction: column;
        gap:1.5rem;
        background: #FFFFFF;
        border: 2px solid #090458;
        border-radius: 9px;
        padding:5% 2%;
        animation: scroll 200s linear infinite;

        @keyframes scroll {
            to {
              transform: translateX(calc(-250px * 7));
            }
          }
        @media screen and (max-width: 768px) {
            min-width: 85%;
            height: 200px;
            gap:0.5rem;
            // background:red;
        }

`;
export const TopSection = styled.div`
    display:flex;
    justify-content:;
    align-items:center;
    position:relative;

    span{
        position: absolute;
        top:0px;
        right:10px;
        border:1px solid ${mainColor};
        width:15px;
        height:15px;
        transform: rotate(50deg);
    }

`;
export const BottomSection = styled.div`

`;
export const ImageWrap = styled.div`
    @media screen and (max-width: 768px) {
        img{
            width: 50%;
            height:50%;
        }
    }
`;
export const TestimonialTitle = styled.h2`
    font-weight: 750;
    font-family: ${mainFont};
    color:${mainColor};
    font-weight: 750;
    font-size: 25px;
    line-height: 30px;
    letter-spacing: 0.01em;
    margin-left:1rem;
    @media screen and (max-width: 768px) {
        font-style: normal;
        font-weight: 750;
        font-size: 14.4958px;
        line-height: 25px;
    }
`;







